import Modal from 'LuxKit/Modal/Modal'
import React, { useState } from 'react'
import RequestDemoForm from './RequestDemoForm'

export default function BusinessTravellerRequestDemoModal() {
  const [finished, setFinished] = useState(false)

  const handleSuccess = () => {
    setFinished(true)
  }

  return (
    <Modal size={finished ? 'S' : 'L'} title={finished ? 'Thank you!' : 'Request a demo'}>
      <RequestDemoForm onSuccess={handleSuccess} />
    </Modal>
  )
}
